module.exports = __webpack_public_path__ + "img/Xbox-One-banner.9d50cf12.png";